import NBType, { InferType } from '@netbase/nb-type'
import AuthRoleSchema from './AuthRoleSchema'

const AuthUserRoleSchema = NBType.object().shape('AuthUserRoleSchema', {
  /* @prop */
  role: AuthRoleSchema,
  /* @prop */
  userRoleId: NBType.number()
  /* END */
})
export default AuthUserRoleSchema
export type AuthUserRole = InferType<typeof AuthUserRoleSchema>
// RESERVE BELOW
